module.exports = __webpack_public_path__ + "img/mivivienda.6e09f46e.svg";